import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

export default function WhatsAppButton() {
  const waNumber = '6281999934451';
  const waMessage = encodeURIComponent('Halo Bewhy, saya tertarik untuk konsultasi tentang...');
  const waLink = `https://wa.me/${waNumber}?text=${waMessage}`;

  return (
    <motion.a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform duration-300 hover:scale-110 hover:-translate-y-1"
      style={{ background: '#25D366' }}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 2, type: 'spring', stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
    >
      <MessageCircle size={24} color="#fff" fill="#fff" />
    </motion.a>
  );
}
